import script from "./OffboardingMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./OffboardingMessage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__